import { type ApiErrorResponse } from "@root/shared/types/type";

export const isString = (value: unknown): value is string => {
  return typeof value === "string" || value instanceof String;
};

export const isNumber = (value: unknown): value is number => {
  return typeof value === "number";
};

export const isApiError = (value: unknown): value is ApiErrorResponse =>
  typeof value === "object" && value !== null && "status" in value && value.status === false;
